import { render, staticRenderFns } from "./RegistrationAgreement.vue?vue&type=template&id=3b49c26b&scoped=true&"
import script from "./RegistrationAgreement.vue?vue&type=script&lang=js&"
export * from "./RegistrationAgreement.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationAgreement.vue?vue&type=style&index=0&id=3b49c26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b49c26b",
  null
  
)

export default component.exports